module.exports = __webpack_public_path__ + "img/intercultural_inv_award.4075b948.svg";